import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import OwnerEarningsContainer from './OwnerEarningsContainer';
import messages from '../../locale/jsonMessages';

// "Revenue & payouts" (owner reporting). Reachable from the owner side menu (block 6) and by its URL. Same rules as the other owner pages:
// anonymous visitors go to the login page; the data query refuses administrators and anyone who is not logged in as an owner.
export default async function action({ store, query, intl }) {
  const title = intl?.formatMessage(messages.orpEarningsTitle);

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout ownerMenuPath="/owner/earnings" ownerMenuWrapContent><OwnerEarningsContainer query={query} /></UserLayout>,
  };
};
